<div class="multistub">
<h2 class="multistub-heading">Choose your user ID</h2>
<p>You have mutiple user IDs associated with your profile. Select the ID for the account you want to manage.</p>
    <ul>
        <li *ngFor="let stubId of listOfStubIds" ><a href="javascript:void(0)" (click)="onSelectStubId(stubId)" >{{stubId}}</a></li>
    </ul>
</div>
     
    
